import { permissionsByEntity, useCheckPermissions } from '@cmg/auth';

export type AccessCheckResult = {
  canRead: boolean;
  canUpdate: boolean;
};

export function useCheckWallCrossAccess(): AccessCheckResult {
  const canRead = useCheckPermissions([permissionsByEntity.WallCross.READ]);
  const canUpdate = useCheckPermissions([permissionsByEntity.WallCross.FULL]);

  return { canRead, canUpdate };
}
